define(['jquery', 'matchMedia'], $ => {
    let timeout;
    const delay = 500;

    return {
        settings: {
            $body: $('body'),
        },

        init() {
            this.initStates();
            this.addBodyClass();
            this.bindEvents();
            this.checkState();
            this.checkPlatform();
        },

        getWidth() {
            return window.innerWidth ? window.innerWidth : $(window).width();
        },

        initStates() {
            window.maxMobile = 767;
            window.maxTablet = 1024;
            window.minTablet = window.maxMobile + 1;
            window.minDesktop = window.maxTablet + 1;
        },

        addBodyClass() {
            const width = this.getWidth();

            this.settings.$body.toggleClass(
                'desktop',
                width > window.maxTablet
            );
            this.settings.$body.toggleClass(
                'tablet',
                width >= window.minTablet && width <= window.maxTablet
            );
            this.settings.$body.toggleClass('mobile', width < window.maxMobile);
            this.settings.$body.toggleClass(
                'android',
                navigator.userAgent.match(/Android/i) !== null
            );
            this.settings.$body.toggleClass(
                'safari',
                navigator.userAgent.match(/Safari/i) !== null &&
                    navigator.userAgent.match(/Chrome/i) === null
            );
            this.settings.$body.toggleClass(
                'firefox',
                navigator.userAgent.match(/Firefox/i) !== null
            );

            if (!('ontouchstart' in document.documentElement)) {
                this.settings.$body.addClass('no-touch');
            }
        },

        bindEvents() {
            $(window).on('resize', this.resize.bind(this));
        },

        checkState() {
            this.settings.$body.attr('data-old-state', this.detectState());
        },

        detectState() {
            const width = this.getWidth();

            if (width > window.maxTablet) {
                return 'desktop';
            } else if (width <= window.maxTablet && width >= window.minTablet) {
                return 'tablet';
            }

            return 'mobile';
        },

        checkPlatform() {
            if (
                navigator.platform &&
                navigator.platform.toUpperCase().indexOf('WIN') >= 0
            ) {
                this.settings.$body.addClass('windows');
            }

            if (
                navigator.userAgent.indexOf('Firefox') !== -1 &&
                parseFloat(
                    navigator.userAgent.substring(
                        navigator.userAgent.indexOf('Firefox') + 8
                    )
                ) >= 3.6
            ) {
                this.settings.$body.addClass('firefox');
            }
        },

        resize() {
            clearTimeout(timeout);

            timeout = setTimeout(() => {
                this.addBodyClass();
                this.settings.$body.attr(
                    'data-old-state',
                    this.settings.$body.attr('data-state')
                );
                this.settings.$body.attr('data-state', this.detectState());

                if (
                    this.settings.$body.attr('data-old-state') !==
                    this.settings.$body.attr('data-state')
                ) {
                    this.settings.$body.trigger('change-state');
                }

                this.settings.$body.trigger('resize-body');
            }, delay);
        },
    };
});
